import { useI18n } from "../../../i18n/i18n";
export var useA11yStatusMessages = function useA11yStatusMessages() {
  var _useI18n = useI18n(),
    i18n = _useI18n.i18n;
  var getA11yStatusMessage = function getA11yStatusMessage(_ref) {
    var isOpen = _ref.isOpen,
      resultCount = _ref.resultCount,
      previousResultCount = _ref.previousResultCount;
    if (!isOpen) {
      return "";
    }
    if (!resultCount) {
      return i18n._( /*i18n*/"No results found.");
    }
    if (resultCount !== previousResultCount) {
      return i18n._( /*i18n*/{
        id: "{resultCount, plural, one {# result is} other {# results are}} available, use up and down arrow keys to navigate. Press Enter key to select.",
        values: {
          resultCount: resultCount
        }
      });
    }
    return "";
  };
  var getA11ySelectionMessage = function getA11ySelectionMessage(_ref2) {
    var selectedItem = _ref2.selectedItem,
      itemToStringLocal = _ref2.itemToString;
    return selectedItem ? i18n._( /*i18n*/{
      id: "{itemAsString} has been selected.",
      values: {
        itemAsString: itemToStringLocal(selectedItem)
      }
    }) : "";
  };
  return {
    getA11ySelectionMessage: getA11ySelectionMessage,
    getA11yStatusMessage: getA11yStatusMessage
  };
};
//# sourceMappingURL=useA11yStatusMessages.js.map